import { DeviceInformation as DeviceInformationModel } from '@rocksoft/mdm-sdk-v2';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export interface DeviceInformation extends DeviceInformationModel {
  udid: string;
}

export type DeviceInformationState = EntityState<DeviceInformation>;

export function selectId(deviceInformation: DeviceInformation): string {
  return deviceInformation.udid;
}

export const adapter: EntityAdapter<DeviceInformation> = createEntityAdapter<DeviceInformation>({
  selectId,
});

export const initialState: DeviceInformationState = adapter.getInitialState();
